import "@/App.css";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ab8dbd92-4b3a-4abb-b82c-978af6903621/artifacts/urvtk5z2_logo-saucedo-abogados-blanco.webp";

function App() {
  return (
    <div className="thank-you-page" data-testid="thank-you-page">
      {/* Background overlay */}
      <div className="background-overlay"></div>
      
      {/* Content */}
      <div className="content-wrapper">
        {/* Logo */}
        <img 
          src={LOGO_URL} 
          alt="Saucedo Abogados" 
          className="logo"
          data-testid="logo"
        />
        
        {/* Main Title */}
        <h1 className="main-title" data-testid="main-title">
          Gracias por contactarnos
        </h1>
        
        {/* Message */}
        <p className="message-text" data-testid="message-text">
          Nuestro equipo se pondrá en contacto contigo en breves instantes.
        </p>
        <p className="message-text" data-testid="message-text-2">
          Mientras tanto, te agradecemos tu confianza.
        </p>
      </div>
    </div>
  );
}

export default App;
